import React from "react";
import {useFunnelNavigation} from "../../hooks/useFunnelNavigation";
import {Footer} from "../common/Footer";

export function FeaturesPreview({config}) {
    const {nextStep} = useFunnelNavigation();

    return (
        <div className="flex flex-col min-h-screen relative overflow-hidden px-4 py-6">
            {/* Content */}
            <div className="relative z-10 container mx-auto max-w-2xl">
                {/* Header */}
                <div className="text-center mb-8">
                    <h1 className="text-2xl font-bold text-gray-900 leading-tight">
                        {config.title}
                    </h1>
                </div>

                {/* Features Grid */}
                <div className="flex-1">
                    <div className="grid grid-cols-2 gap-4">
                        {config.features.map((feature, index) => (
                            <div
                                key={index}
                                className="bg-white/90 backdrop-blur-sm p-4 rounded-xl border border-gray-100 shadow-sm"
                            >
                                <div className="flex flex-col items-center text-center space-y-2">
                                    <span className="text-3xl mb-2">{feature.icon}</span>
                                    <h3 className="font-semibold text-gray-900">
                                        {feature.title}
                                    </h3>
                                    <p className="text-sm text-gray-500">{feature.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Button */}
                <div className="mt-8">
                    <Footer onClick={nextStep}>{config.buttonText || "Next"}</Footer>
                </div>
            </div>
        </div>
    );
}
